import { useAutoCompleteStore } from '@pkgs/components/hooks/stores/useAutoCompleteStore';
import { Copy } from '@ev-tech/ui-core-components/Copy';

export const HighlightedText = ({ text }: { text: string }) => {
  const inputText = useAutoCompleteStore((state) => state.inputText);
  if (!inputText) {
    return <Copy text={text} as="span" />;
  }
  const escapedHighlightedText = inputText.replaceAll(/[$()*+.?[\\\]^{|}]/g, String.raw`\$&`);

  const regex = new RegExp(`(${escapedHighlightedText})`, 'gi');
  const parts = text.split(regex);

  return (
    <>
      {parts.map((part, index) =>
        part.toLowerCase() === inputText.toLowerCase() ? (
          <Copy key={index} text={part} bold as="span" />
        ) : (
          <Copy key={index} text={part} as="span" />
        ),
      )}
    </>
  );
};
